/* Komponen kecil dikongsi page Admin → Formulas (prototaip design, 27 Okt 2026). Gaya: FormulaAdmin.css (fma-). */

export function Suis({ on, onTukar, label }) {
    return (
        <button type="button" role="switch" aria-checked={on} aria-label={label}
            className={'fma-sw' + (on ? ' is-on' : '')}
            onClick={(e) => { e.stopPropagation(); onTukar(!on); }} />
    );
}

export function Pils({ pilihan, nilai, onTukar, label = (x) => x }) {
    const togol = (x) => onTukar(nilai.includes(x) ? nilai.filter((v) => v !== x) : [...nilai, x]);
    return (
        <div className="fma-pils">
            {pilihan.map((x) => (
                <button key={x} type="button" aria-pressed={nilai.includes(x)}
                    className={'fma-pil' + (nilai.includes(x) ? ' is-on' : '')} onClick={() => togol(x)}>{label(x)}</button>
            ))}
        </div>
    );
}

export function Medan({ id, label, nota, children }) {
    return (
        <div className="fma-medan">
            {label && (id ? <label htmlFor={id}>{label}</label> : <span className="fma-lbl">{label}</span>)}
            {children}
            {nota && <p className="fma-medan__nota">{nota}</p>}
        </div>
    );
}

export function Kotak({ tajuk, kanan, children, style }) {
    return (
        <div className="fma-kotak" style={style}>
            {(tajuk || kanan) && <p className="fma-kotak__tajuk"><span>{tajuk}</span>{kanan}</p>}
            {children}
        </div>
    );
}

export function BarisSuis({ nama, nota, on, onTukar }) {
    return (
        <div className="fma-baris">
            <span><span className="fma-block__nama">{nama}</span>{nota && <span className="fma-block__nota" style={{ whiteSpace: 'normal' }}>{nota}</span>}</span>
            <Suis on={on} label={nama} onTukar={onTukar} />
        </div>
    );
}
